<template>
  <div v-if="maxBidCreatedModal.lot.currency" class="ta-max-bid-created-modal-data ta-max-bid-created-modal-bid-increment">
    <div class="ta-data-label">
      {{ label }}
    </div>
    <div class="ta-data-value">
      {{nextIncrement | asCurrency(maxBidCreatedModal.lot.currency.code)}}
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {getIncrements} from "@/helpers";

export default {
  name: "BidIncrement",
  props: {
    label: {
      type: String,
      default() {
        return this.$t('Bid Increment')
      }
    }
  },
  computed: {
    ...mapState(['maxBidCreatedModal']),
    nextIncrement() {
      const increments = getIncrements(this.maxBidCreatedModal.lot);
      return increments[0]?.increment
    }
  }
}
</script>

<style scoped>

</style>
